import React, {Component} from 'react';
import {
    FEATURE_FLAGS_CONFIG,
    FEATURE_FLAGS,
    onFlagChange,
    setFeatureFlag
} from '../../services/feature_flags';
import stopEvent from '../../utils/stop_event';

export default class FeatureFlagForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: {},
        };
        this.state.values = {...FEATURE_FLAGS};
    }

    componentDidMount() {
        this.unbinders = Object.keys(FEATURE_FLAGS_CONFIG).map(flag => onFlagChange(flag, this.updateFlagValue(flag)));
    }

    componentWillUnmount() {
        for (const unbindFn of this.unbinders) {
            unbindFn();
        }
    }

    handleFlagValueChange(flag) {
        const valueProp = FEATURE_FLAGS_CONFIG[flag].type === 'boolean' ? 'checked' : 'value';
        return function (ev) {
            setFeatureFlag(flag, ev.target[valueProp]);
        }
    }

    updateFlagValue(flag) {
        return (value) => {
            const {values} = this.state;
            values[flag] = value;
            this.setState({values});
        }
    }

    renderInput(flag, config) {
        const value = this.state.values[flag];
        const onChange = this.handleFlagValueChange(flag);
        switch (config.type) {
            case 'boolean':
                return (
                    <input
                        type="checkbox"
                        onChange={onChange}
                        checked={value}
                    />
                );
            case 'string':
            case 'number':
                return (
                    <input
                        type={config.type === 'string' ? 'text' : config.type}
                        onChange={onChange}
                        value={value}
                    />
                );
            case 'enum':
                return (
                    <select
                        onChange={onChange}
                        value={value}
                    >
                        {config.options.map(option => (
                            <option
                                value={option}
                                key={option}
                            >
                                {option}
                            </option>
                        ))}
                    </select>
                );
            default:
                return null;
        }
    }

    render() {
        return (
            <form onSubmit={stopEvent} className="feature-flag-form">
                {Object.entries(FEATURE_FLAGS_CONFIG).map(([flag, config]) => (
                    <label key={flag}>
                        {this.renderInput(flag, config)}
                        {config.name}
                    </label>
                ))}
            </form>
        );
    }
}
